import { useAuth } from '../context/AuthContext';

export function useApi() {
  const { token } = useAuth();
  const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7777';

  async function request(path, options) {
    const headers = options && options.headers ? options.headers : {};
    if (token) headers['Authorization'] = `Bearer ${token}`;
    if (!(options?.body == null) && !headers['Content-Type'] && !(options?.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }
    const res = await fetch(base + path, { ...options, headers });
    if (res.status === 401 || res.status === 403) {
      try { window.localStorage.removeItem('pd_token'); } catch {}
      // hard redirect to login
      if (window.location.pathname !== '/') window.location.href = '/';
    }
    return res;
  }

  return { request };
}


